export const purple = '#AC8EE6';
export const green ='#4FB99E';
export const gading = '#E7F3FE';